import React, {useRef, useState, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import { useTranslation } from 'react-i18next';
import * as actions from '../../store/actions/index';
import Aux from '../../hoc/Aux';
import useWindowDimensions from '../../hooks/useWindowDimensions';
import 'react-sliding-side-panel/lib/index.css';
import MediumFilterButton from './MediumFilterButton'
import SelectedLinesFilterButton from './SelectedLinesFilterButton'
import ProductSystemTableRow from './ProductSystemTableRow'
import ProductSystemTableHead from './ProductSystemTableHead'

import Select from 'react-select'
import { useForm, Controller } from "react-hook-form"

const ProductSystemItemsSingleTable = (props) => {

  const { t } = useTranslation();
  const defaultSortDirection = 1;
  const globalGap = props.globalGap;
  const updateFilterParent = props.updateFilter;
  const updateMediumFilterParent = props.updateMediumFilter;


  const getInitialMediumFilterStatus = (medium) => {
    const types = props.selectedSteps['mediumTypes'];

    if ((Array.isArray(types) && types.length === 0) || (types === undefined)) {
      return true;
    } else {
      return types.includes(medium)
    }
  }

  const [statusInitialized, setStatusInitialized] = useState(false);

  // multiSelect Durchführungen 
  const [penetrationOptions, setPenetrationOptions] = useState([]);
  const [selectedPenetration, setSelectedPenetration] = useState([]);

  const [insulationOptions, setInsulationOptions] = useState([]);
  const [selectedInsulation, setSelectedInsulation] = useState([]);

  const [productOptions, setProductOptions] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState([]);

  const { register, control, setValue } = useForm();

  // selectedItems sind die gewählten items, die von außen in die Komponente eingegeben werden
  // Zur Anzeige wird hier jedoch selectedSystemItems genutzt.

  const selectedItems = props.selectedItems || [];
  const [sortColumn, setSortColum] = useState('penetrations');
  const [sortDirection, setSortDirection] = useState(defaultSortDirection); // 1 oder -1
  const [selectedSystemItemsWithAmount, setSelectedSystemItemsWithAmount] = useState(selectedItems);
  const [selectedSystemItemsFullObjects, setSelectedSystemItemsFullObjects] = useState([]);
  const [mediumFilters, setMediumFilters] = useState(props.availableMediumTypes.reduce( (a,b) => ( a[b] = getInitialMediumFilterStatus(b), a), {}));

  // Zeilen, die grün markiert werden. In den "selectedSystemItems" stecken auch immer die global selektierten Zeilen.
  // Manchmal möchte man aber auch die Zeilen haben die in diesem SingleTable markiert sind, um sie z.B. als Zahl anzuzeigen.

  const countGreenLines = (items) => selectedSystemItemsWithAmount.filter( (x) => items.map( y => y.id ).includes( x.id )).length;

  const filterSelectedInit = ((props.showModus === 'modalVersion' || props.showModus === 'sharedUID')) ? true : false;
  const [filterSelected, setFilterSelected] = useState(filterSelectedInit);
  const refContainer = useRef();

  let productSystem = {};

  const {
    height,
    width
  } = useWindowDimensions();

  const [heightDisplayRows, setHeightDisplayRows] = useState(height);

  const [buttons, setButtons] = useState([]);

  const dispatch = useDispatch();

  // Die Daten der Tabellenzeilen (ProductSystemItems)

  useEffect(() => { dispatch( actions.fetchProductSystem(props.productSystem)) }, []);

  const thisProductSystem = useSelector(state => {
    return (productSystemId) => actions.getProductSystem(state, productSystemId)
  });
  const loadingProductSystem = useSelector(state => state.inventory.loadingProductSystem );


  useEffect(() => {
    dispatch(actions.fetchProductsolutions(props.selectedSteps)).then((res) => setButtons(res));
  }, []);

  useEffect(() => {
    updateMediumFilterValues();
  }, []);

  // productSystemItems sind ALLE items, die es in einem Produktsystem gibt
  const initalFiltersSettings = useSelector(state => actions.getWizardFilterSelectProductSystem(state)); 
  const productSystemsItems = useSelector(state => actions.getReduxObjects(state.inventory.productSystemItems, buttons));
  const allMediumTypes = [...new Set(productSystemsItems.map(x => x.medium_type)) ];
  const productSystemsItemsCount = productSystemsItems.length;

  useEffect(() => {
    if (productSystemsItems.length > 0 && mediumFilters !== undefined && mediumFilters !== null ) {
      let filtered_medium_types = Object.assign(...Object.keys(mediumFilters)
                               .filter( key => allMediumTypes.includes(key) )
                               .map( key => ({ [key]: mediumFilters[key] }) ), {});
      setMediumFilters(filtered_medium_types);
    }

    // Dieser Filter dient dazu, dass nur die items angezeigt werden, die auch zu den aktivierten MediumTypes
    // passen. Rein theoretisch könnten MediumTypes abgewählt werden, was zu einer Deselektierung von
    // items führen würde. Das wird aber praktisch an einer anderen Stelle unterbunden, da es nicht möglich ist
    // einen MediumType abzuwählen, wenn ein item aktiviert ist, das mit diesem Typ verbunden ist. So gesehen erscheint
    // dieser Filter hier momentan nicht nötig zu sein.

    // Da es auch den MediumType "Leerschott" gibt, der nicht eindeutig einer der beiden Tabellen zugeordnet werden kann
    // muss es hier auch noch eine Filterung nach line_type geben (Rohr oder Kabel)


    const items = productSystemsItems.filter(function(item, index, arr) {
            return projectInLineTypeFilter(item)
          }).filter(function(item, index, arr) {
                                                        return selectedSystemItemsWithAmount.map(x=>x.id).includes(item.id)
                                                      }).filter(function(item, index, arr) {
                                                       return props.availableMediumTypes.includes(item.medium_type)
                                                     });
    setSelectedSystemItemsFullObjects( items );

    if (productSystemsItemsCount > 0 && countGreenLines(items) === 0) {
      setFilterSelected(false);
    }

    clearAllSelectFilters();
    setInitalSelectboxValues();

  }, [productSystemsItemsCount]);


  const setInitalSelectboxValues = () => {
    calculatePenetrationOptions(findOutSelectableItems(productSystemsItems)).forEach((item) => {
      if (initalFiltersSettings.penetrationId === item.value) {
        setSelectedPenetration([item]);
      }
    });

    calculateInsulationOptions(findOutSelectableItems(productSystemsItems)).forEach((item) => {
      if (initalFiltersSettings.insulationId === item.value) {
        setSelectedInsulation([item]);
      }
    });

    calculateProductOptions(findOutSelectableItems(productSystemsItems)).forEach((item) => {
      if (initalFiltersSettings.productgroupId === item.value) {
        setSelectedProduct([item]);
      }
    });

  }
    

  const clearAllSelectFilters = () => {  
    setPenetrationOptions(calculatePenetrationOptions(findOutSelectableItems(productSystemsItems)));
    setSelectedPenetration([]); // reset 
    setInsulationOptions(calculateInsulationOptions(findOutSelectableItems(productSystemsItems)));
    setSelectedInsulation([]); // reset
    setProductOptions(calculateProductOptions(findOutSelectableItems(productSystemsItems)));
    setSelectedProduct([]); // reset
  }

  // useEffect(() => {
  //   clearAllSelectFilters();
  // }, []); 

  useEffect(() => {
    setInsulationOptions(calculateInsulationOptions(findOutSelectableItems(productSystemsItems)));
    setProductOptions(calculateProductOptions(findOutSelectableItems(productSystemsItems)));
    updateFilterValues();
  }, [ selectedPenetration ]); 

  useEffect(() => {
    setPenetrationOptions(calculatePenetrationOptions(findOutSelectableItems(productSystemsItems)));
    setProductOptions(calculateProductOptions(findOutSelectableItems(productSystemsItems)));
    updateFilterValues();
  }, [ selectedInsulation ]);

  useEffect(() => {
    setPenetrationOptions(calculatePenetrationOptions(findOutSelectableItems(productSystemsItems)));
    setInsulationOptions(calculateInsulationOptions(findOutSelectableItems(productSystemsItems)));
    updateFilterValues();
  }, [  selectedProduct ]); 

  useEffect(() => {
    updateMediumFilterValues()
  }, [ mediumFilters ]);

  const updateFilterValues = () => {
    const penetrations = selectedPenetration.map(x => x.value);
    const insulations = selectedInsulation.map(x => x.value);
    const products = selectedProduct.map(x => x.value);
    updateFilterParent()({penetrations: penetrations, insulations: insulations, products: products});
  }  


  const updateMediumFilterValues = () => {
    const tmpMediumTypes = Object.keys(mediumFilters).filter( key => mediumFilters[key] === true );
    updateMediumFilterParent()(tmpMediumTypes);
  }

  const customSelectStyles = {
    groupHeading: () => ({
      color: "black",
      marginLeft: "10px",
      marginBottom: "10px",
      fontSize: "1.2em"

    }),

  }

  const onChangePenetration = (e) => {
    const new_value = (e !== null) ? e : [];
    setSelectedPenetration(new_value);
  }

  const onChangeInsulation = (e) => {
    const new_value = (e !== null) ? e : [];
    console.log('onChangeInsulation', e);
    setSelectedInsulation(new_value);
  }

  const onChangeProduct = (e) => {
    const new_value = (e !== null) ? e : [];
    setSelectedProduct(new_value);
  }

  const findOutSelectableItems = (items) => {
    return items.filter(function(item, index, arr) {
      return projectInMediumFilter(item)
    }).filter(function(item, index, arr) {
      return projectInLineTypeFilter(item)
    })
  }

  const calculateInsulationOptions = (items) => {
    let tmp = [];
    let tmp2 = []; 
    let tmp3 = [];

    // generiere eine Basisliste mit allen Durchführungen (ohne Duplikate)
    items.forEach((item) => {
      if (item.insulation !== null && item.insulation !== undefined && item.insulation !== "" && !tmp.includes(item.insulation)) {
        // Berücksichtigung der Auswahl der Durchführungen und der Produkte
        if ( projectInPenetrationFilter(item) && projectInProductFilter(item) ) {
          tmp3.push({ id: item.insulation_id, token: item.insulation });
          tmp.push(item.insulation);
        }
      }
    });
    
    tmp3.forEach((insulation) => {
      tmp2.push(
        { 
          value: insulation.id, 
          label: t(insulation.token) 
        }); 

    });
   
    tmp2 = tmp2.sort((a, b) => a.label < b.label ? -1 : 1)

    return [...new Set(tmp2)];
  }


  const calculatePenetrationOptions = (items) => {
    let tmp = [];
    let tmp2 = []; 
    let tmp3 = [];

    // generiere eine Basisliste mit allen Durchführungen (ohne Duplikate)
    items.forEach((item) => {
      if (item.penetrations !== null && item.penetrations !== undefined && item.penetrations !== "" && !tmp.includes(item.penetrations)) {
        // Berücksichtigung der Auswahl der Isolierungen und der Produkte
        if ( projectInInsulationFilter(item) && projectInProductFilter(item) ) {
          tmp3.push({ id: item.penetration_id, token: item.penetrations });
          tmp.push(item.penetrations);
        }
      }
    });
    
    tmp3.forEach((penetration) => {
      tmp2.push(
        { 
          value: penetration.id, 
          label: t(penetration.token) 
        }); 
    });
   
    tmp2 = tmp2.sort((a, b) => a.label < b.label ? -1 : 1)

    return [...new Set(tmp2)];
  }


  const calculateProductOptions = (items) => {
    let tmp = [];
    let tmp2 = [];

    // generiere eine Basisliste mit allen Produkte (ohne Duplikate)
    items.forEach((item) => {
      if (item.products !== null && item.products !== undefined && item.products !== "" && item.product !== []) {
        if ( projectInPenetrationFilter(item) && projectInInsulationFilter(item) ) {
          item.products.forEach((product) => {
            if (!tmp.map(x => x.value).includes(product.id)) {
              tmp.push({ value: product.id, label: product.title });
            }
          });
        }
      }
    });
    
    tmp = tmp.sort((a, b) => a.label < b.label ? -1 : 1)

    return [...new Set(tmp)];
  }






  const loading = useSelector(state => state.inventory.loadingProductSolution);

  const getItemWithAmount = (item) => (
    selectedSystemItemsWithAmount.find(
      function(value, index, arr) {
        return value.id === item.id;
      }
    )
  )

  const undefinedToZero = (x) => {
    return (x === null || x === undefined)? 0 : x
  }

  const isItemSelected = (item) => {
    const i = getItemWithAmount(item);
    return (i !== null && i !== undefined);
  };

  const getItemAmount = (item) => {
    const i = getItemWithAmount(item);
    return (i !== null && i !== undefined)? i['amount'] : undefined;
  }


  const projectInLineTypeFilter = (item) => {
    const lineType = (props.tableType === "tube")? "rohr" : "kabel";
    return item.line_type === lineType;
  }

  const projectInMediumFilter = (item) => {
    return Object.entries(mediumFilters).filter(([key, value]) => value === true).map(x => {const [a, b] = x; return a} ).includes(item.medium_type)
  }

  const projectInPenetrationFilter = (item) => {
    return (selectedPenetration.length > 0)? selectedPenetration.map(x => x.value).includes(item.penetration_id) : true;
  }

  const projectInInsulationFilter = (item) => {
    return (selectedInsulation.length > 0)? selectedInsulation.map(x => x.value).includes(item.insulation_id) : true;
  }

  const projectInProductFilter = (item) => {
    const product_ids = item.products.map(x => x.id)
    return (selectedProduct.length > 0)? selectedProduct.map(x => x.value).filter( x => product_ids.includes(x)).length > 0 : true;
  }

  let projectlist = <tr>
    <td colspan="12">leer</td>
  </tr>;


  // Wenn eine Zeile komplett gelöscht werden soll, dann wird der Amount nicht um 1 erniedrigt, sondern der Amount wird
  // komplett auf 0 gesetzt, bzw. der Eintrag wird komplett aus dem Array entfernt.
  const deleteProductSystemItem = (itemId) => {

    setSelectedSystemItemsWithAmount(selectedSystemItemsWithAmount
      .filter(function(value, index, arr) {
        return value.id !== itemId;
    }))

    // Für die Anzeige der Anzahl gewählter Lines in den Buttons.
    // Dort braucht man die MediumTypes, die an den Items dranhängen.
    let newSelectedItems = selectedSystemItemsFullObjects.filter(function(value, index, arr) {
      return value.id !== itemId;
    });

    setSelectedSystemItemsFullObjects( newSelectedItems )
    substractProductSystemItemParent(itemId, 0)

    // Filter deaktivieren?
    if (countGreenLines(newSelectedItems) === 0 ){
      setFilterSelected(false);
    }
  }


  const substractProductSystemItem = (item) => {
    const amount = undefinedToZero(getItemAmount(item)) - 1;
    const itemId = item.id

    // Das Item einfach herauslöschen, wenn es nur noch einmal vorhanden ist
    if (amount < 1) {
      deleteProductSystemItem(itemId)
    // oder um 1 erniedrigen
    } else {
      setSelectedSystemItemsWithAmount(
        Array.from(
          new Set([...selectedSystemItemsWithAmount
            .filter(
              function(value, index, arr) {
                return value.id !== itemId;
              }
            ), { id: itemId, amount: amount }]
          )
        )
      )
    }
    substractProductSystemItemParent(itemId, amount)
  }

  const addProductSystemItem = (item) => {
    const amount = undefinedToZero(getItemAmount(item)) +1;
    const itemId = item.id
    const updatedItem = { id: itemId, amount: amount }

    if (item.gap === globalGap || globalGap === undefined) {
      setSelectedSystemItemsWithAmount(
        Array.from(
          new Set([...selectedSystemItemsWithAmount
            .filter(
              function(value, index, arr) {
                return value.id !== itemId;
              }
            ), updatedItem]
          )
        )
      )

      setSelectedSystemItemsFullObjects(Array.from(new Set([
        ...selectedSystemItemsFullObjects,
        item
      ])))

      addProductSystemItemParent(itemId, updatedItem)
    }
  }


  const onFilterTableColumnsAction = (column) => {
    if (column === sortColumn){
      setSortDirection(-sortDirection);
    } else {
      setSortColum(column);
      setSortDirection(defaultSortDirection);
    }
  }



  const addProductSystemItemParent = (itemId, updatedItem) => {
    if (props.addProductSystemItemParent !== undefined) {
      props.addProductSystemItemParent()(itemId, updatedItem);
    }
  }

  const substractProductSystemItemParent = (itemId, amount) => {
    if (props.substractProductSystemItemParent !== undefined) {
      props.substractProductSystemItemParent(itemId, amount);
    }
  }


  // Filter Selected (green) Lines
  const toggleFilterSelected = () => {
    setFilterSelected(!filterSelected);
    if (filterSelected === false && refContainer.current !== null && refContainer.current !== undefined) {
      refContainer.current.value = "";
    }
  }

  if (!loading) {

    projectlist = productSystemsItems
      .filter(function(item, index, arr) {
        return (filterSelected === true) ? isItemSelected(item) : true
      })
      .filter(function(item, index, arr) {
        return projectInMediumFilter(item)
      })
      .filter(function(item, index, arr) {
        return projectInLineTypeFilter(item)
      })
      .filter(function(item, index, arr) {
        return projectInPenetrationFilter(item)
      })
      .filter(function(item, index, arr) {
        return projectInInsulationFilter(item)
      }) 
      .filter(function(item, index, arr) {
        return projectInProductFilter(item)
      }) 
      .sort((a, b) => t(a[sortColumn]) > t(b[sortColumn]) ? sortDirection : -sortDirection)
      .map((item, i) => {

        let color = (i % 2) ? "odd" : "even"
        let isSelected = isItemSelected(item)

        // Tabelle: Die erste Spalte sollte linksbündig dargestellt werden.
        // Text in Zellen grundsätzlich lieber linksbündig, Zahlen lieber rechtsbündig.
        // Rohrendkonfiguration kann mittig bleiben, da immer 3 Zeichen.

        if (isSelected) {
          return (
            <tr key={item.id}>
              <ProductSystemTableRow
                isSelected={true}
                color={"selected"}
                item={item}
                itemId={item.id}
                amount={getItemAmount(item)}
                tableType={props.tableType}
                onToggle={()=>deleteProductSystemItem(item.id)}
                onAdd={()=>addProductSystemItem(item)}
                onSubstract={()=>substractProductSystemItem(item)}
                />
            </tr>
          )
        } else {
          return (
            <tr key={item.id} onClick={()=>addProductSystemItem(item)}>
              <ProductSystemTableRow
                globalGap={globalGap}
                isSelected={false}
                color={color}
                item={item}
                itemId={item.id}
                amount={null}
                tableType={props.tableType}
                onToggle={()=>addProductSystemItem(item)}
              />
            </tr>
          )
        }

      })
  }

  const horizontalScrollBreakpoint = 1440;

  const computeMaxHeight = (height) => {
    const minimumTableHeight = 250;
    const computeTableHeight = height - 650 // 650 für die Daten über der Tabelle
    return Math.max(minimumTableHeight, computeTableHeight) + "px";
  }

  const cssTable = (width) => {
    if (width > horizontalScrollBreakpoint) {
      return {
        width: "100%",
        tableLayout: "fixed",
        overflowWrap: "break-word"
      }
    } else {
      return {
        width: width - 20 + "px"
      }
    }
  }

  const cssDivSolutionTable = (width, height) => {
    return {
      overflowX: (width > horizontalScrollBreakpoint) ? "hidden" : "scroll",
      overflowY: "scroll",
      position: "relative",
      maxHeight: computeMaxHeight(height)
    }
  }

  const showMoreLines = (h) => {
    const newHeight = h + 200;
    setHeightDisplayRows(newHeight);
  }

  const showLessLines = (h) => {
    const newHeight = h - 200;
    setHeightDisplayRows(newHeight);
  }

  const toggleMediumFilter = (medium) => {
    setMediumFilters({...mediumFilters, [medium]: !mediumFilters[medium] });
    clearAllSelectFilters();
  }

  const renderMediumFilters = () => {
    return Object.keys(mediumFilters).map( key => {
      const selectedLineIds = selectedSystemItemsFullObjects.filter( (x) => x.medium_type === key).map(x=>x.id);
      const amountSelectedLines = selectedSystemItemsWithAmount.filter( x => selectedLineIds.includes(x.id) ).reduce((total, num) => total + num['amount'], 0)

      let text = (width > 1120)? 'wizard.steps.medium_type.values.' + key + '.long' : 'wizard.steps.medium_type.values.' + key + '.short'

      return <MediumFilterButton key={key} title={ t(text) }  amountSelectedLines={amountSelectedLines} status={mediumFilters[key]} onClick={() => toggleMediumFilter(key)}/>
    })
  }



  const labelSelectedLinesButton = (lines) => {
     let size = (width > 1120)? ".long" : ".short"

     const itemsCount = countGreenLines(selectedSystemItemsFullObjects)

     if (itemsCount.length === 0) {
       return t('wizard.steps.product_solution.button.selected_lines' + size)
     } else {
       return t('wizard.steps.product_solution.button.selected_lines' + size) + " (" + itemsCount + ")"
     }
   }

  if ( (!loading && Object.keys(mediumFilters).length > 0)  && (!loadingProductSystem || productSystem !== {})) {
    productSystem = thisProductSystem(props.productSystem) || {};

    return (

    <Aux>
     <div className="row content-list-head" style={{justifyContent: "left"}}>
       <h2>{props.headline}</h2>

       {
         // Das ist der Filterbutton "Nur Auswahl anzeigen"
       }

       { (countGreenLines(selectedSystemItemsFullObjects) > 0)?

       <SelectedLinesFilterButton
         title={ labelSelectedLinesButton(selectedSystemItemsWithAmount) }
         selectedStatus={filterSelected}
         onClick={toggleFilterSelected}
         /> : null }

       { (width > 768)? renderMediumFilters() : null }
     </div>


      <div className="row content-list-head" style={{justifyContent: "left", paddingBottom: "20px"}}>

        <div style={{width: "27%", zIndex: "20", paddingRight: "15px"}}>
          <Controller
              control={control}
              name="penetrations"
              defaultValue={selectedPenetration}
              render= {({value, ref}) => (
              <Select
                {...register("penetrationBox")}
                noOptionsMessage={() => t( 'wizard.steps.product_system.select_penetration.no_result' ) }
                isClearable={true}
                styles={customSelectStyles}
                placeholder={ t( 'wizard.steps.product_system_item.select_penetration.placeholder' ) }
                options={penetrationOptions}
                value={selectedPenetration}
                isDisabled={penetrationOptions.length === 0}
                isMulti
                onChange={ (e) => onChangePenetration(e) }
                inputRef={ref}
              />)}
            />  
        </div>

        { (props.tableType === "tube")?

        <div style={{width: "27%", zIndex: "20", paddingRight: "15px"}}>
          <Controller
              control={control}
              name="insulations"
              defaultValue={selectedInsulation}
              render= {({value, ref}) => (
              <Select
                noOptionsMessage={() => t( 'wizard.steps.product_system.select_insulation.no_result' ) }
                isClearable={true}
                styles={customSelectStyles}
                placeholder={ t( 'wizard.steps.product_system_item.select_insulation.placeholder' ) }
                options={insulationOptions}
                value={selectedInsulation}
                isDisabled={insulationOptions.length === 0}
                isMulti
                onChange={ (e) => onChangeInsulation(e) }
                inputRef={ref}
              />)}
            />  
        </div> : null }


        <div style={{width: "27%", zIndex: "20"}}>
          <Controller
              control={control}
              name="products"
              defaultValue={selectedProduct}
              render= {({value, ref}) => (
              <Select
                noOptionsMessage={() => t( 'wizard.steps.product_system.select_insulation.no_result' ) }
                isClearable={true}
                styles={customSelectStyles}
                placeholder={ t( 'wizard.steps.product_system_item.select_product.placeholder' ) }
                options={productOptions}
                value={selectedProduct}
                isDisabled={productOptions.length === 0 }
                isMulti
                onChange={ (e) => onChangeProduct(e) }
                inputRef={ref}
              />)}
            />  
         </div>   
      </div>

      <div className="row" style={{paddingBottom: "20px"}}>
        <div id="solutiontable" style={cssDivSolutionTable(width, heightDisplayRows)}>
          <table className="table table-striped table-body" style={cssTable(width)}>
            <ProductSystemTableHead
              tableType={props.tableType}
              filterTableColumn={((x) => onFilterTableColumnsAction(x))}
              sortColumn={sortColumn}
              sortDirection={sortDirection} />
            <tbody>
              { projectlist }
            </tbody>
          </table>
        </div>

        { (filterSelected === false)?
          <div className="draghandle">
            <button type="button" style={{marginRight: "10px"}} className="btn btn-primary btn-sm" onClick={ () => showMoreLines(heightDisplayRows)}><i className="material-icons" style={{margin: "0px 0 4px 1px", fontWeight: "bold",fontSize: "inherit", verticalAlign: "inherit"}}>arrow_downward</i></button>
            <button type="button" className="btn btn-primary btn-sm" onClick={ () => showLessLines(heightDisplayRows)}><i className="material-icons" style={{margin: "0px 0 4px 1px", fontWeight: "bold", fontSize: "inherit", verticalAlign: "inherit"}}>arrow_upward</i></button>
          </div> : null
        }

      </div>
    </Aux>
  )
  } else {
    return null;
  }

};

export default ProductSystemItemsSingleTable;



// WEBPACK FOOTER //
// ./src/components/Shared/ProductSystemItemsSingleTable.js